var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("button", {
    staticClass: "button small c-nav-button",
    attrs: { type: "button" },
    domProps: {
      innerHTML: _vm._s(_vm.translate("frontend.js.global.button_support"))
    },
    on: {
      click: function($event) {
        $event.preventDefault()
        return _vm.openSupportReveal()
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-760548f5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-760548f5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/frontend/vue/components/support/support-button.vue
// module id = 195
// module chunks = 4